export default __webpack_public_path__ + "static/media/2-3-4.eee40825.jpg";